import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor() { }

  getTokenStorage(): string {
    return sessionStorage.getItem(`${environment.storagePrefix}_token`) ?? '';
  }

  setTokenStorage(token: string): void {
    sessionStorage.setItem(`${environment.storagePrefix}_token`, token);
  }
}
